namespace RioERP.Reports {
    export interface LevelReportForm {
        OrderId: Serenity.IntegerEditor;
        OrderDate: Serenity.DateEditor;
        OrderNumber: Serenity.StringEditor;
        CustomerName: Serenity.StringEditor;
        CustomerMobile1: Serenity.StringEditor;
        CustomerEmail1: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        ProductSpecificationName: Serenity.StringEditor;
        Mode: Serenity.IntegerEditor;
        Level: Serenity.IntegerEditor;
        TotalAmount: Serenity.DecimalEditor;
    }

    export class LevelReportForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.LevelReport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LevelReportForm.init)  {
                LevelReportForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DateEditor;
                var w2 = s.StringEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(LevelReportForm, [
                    'OrderId', w0,
                    'OrderDate', w1,
                    'OrderNumber', w2,
                    'CustomerName', w2,
                    'CustomerMobile1', w2,
                    'CustomerEmail1', w2,
                    'ProductName', w2,
                    'ProductSpecificationName', w2,
                    'Mode', w0,
                    'Level', w0,
                    'TotalAmount', w3
                ]);
            }
        }
    }
}
